import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import RequestApproverDialog from '@Components/RequestApproverDialog/RequestApproverDialog';

/** Approve / Reject buttons for approving managers while the exemption request is SUBMITTED. */
export const ApprovalActionsSection = ({ plan, userId, canDecide, acting, onDecide, onApproverAdded }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [approving, setApproving] = useState(true);
  const [comment, setComment] = useState('');
  const [addApproverOpen, setAddApproverOpen] = useState(false);

  const myApproval = (plan?.approvals || []).find((a) => String(a.approver?.id) === String(userId));

  if (!canDecide) return null;

  if (myApproval) {
    return (
      <Alert severity="info">
        You already {myApproval.approved ? 'approved' : 'rejected'} this exemption request.
      </Alert>
    );
  }

  const open = (value) => {
    setApproving(value);
    setComment('');
    setDialogOpen(true);
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
      <Button variant="outlined" color="warning" onClick={() => setAddApproverOpen(true)}>Add Approver</Button>
      <Button variant="contained" color="success" onClick={() => open(true)} disabled={acting}>Approve Exemption</Button>
      <Button variant="contained" color="error" onClick={() => open(false)} disabled={acting}>Reject Exemption</Button>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{approving ? 'Approve Exemption Request' : 'Reject Exemption Request'}</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            {approving
              ? 'Are you sure you want to approve this exemption request?'
              : 'Are you sure you want to reject this exemption request? The RD will have to revise and resubmit it.'}
          </Typography>
          <TextField
            label={approving ? 'Comment (optional)' : 'Rejection reason'}
            fullWidth
            multiline
            minRows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} disabled={acting}>Cancel</Button>
          <Button
            variant="contained"
            color={approving ? 'success' : 'error'}
            disabled={acting || (!approving && !comment.trim())}
            onClick={async () => {
              const ok = await onDecide(approving, comment);
              if (ok) setDialogOpen(false);
            }}
          >
            {acting ? 'Submitting...' : approving ? 'Confirm Approval' : 'Confirm Rejection'}
          </Button>
        </DialogActions>
      </Dialog>

      <RequestApproverDialog
        open={addApproverOpen}
        onClose={() => setAddApproverOpen(false)}
        exitRequestId={plan?.requestId}
        onSaved={() => {
          setAddApproverOpen(false);
          onApproverAdded?.();
        }}
      />
    </Box>
  );
};

export default ApprovalActionsSection;
